export default "__VITE_ASSET__FTm9P4yc__"